import { createRouteConfig } from 'modules/router/utils/createRouteConfig';

const PATH_AUTH = '/auth/';

export const authRoutesConfig = createRouteConfig(
  {
    auth: {
      path: PATH_AUTH,
      generatePath: () => PATH_AUTH,
    },
  },
  PATH_AUTH,
);
